export default "__VITE_ASSET__c5e2c2b4__"